import * as _ from "recompose";
import * as R from "ramda";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { parse } from "query-string";
import { withPromise } from "react-promisify";
import { signIn, signUp } from "modules/user/auth/endpoints";
import { manualSignIn } from "modules/user/auth/actions";
import { bookTime } from "modules/booking/endpoints";
import * as mixpanel from "core/integrations/mixpanel";
import * as fbPixel from "core/integrations/fb_pixel";
import * as dataLayer from "core/integrations/gtm";
import { onSuccess, onFailure } from "core/react/react-promisify";
import View from "./View";

export default _.compose(
  connect(),
  withRouter,
  _.withState("error", "setError", void 0),
  _.withState("signUpErrors", "setSignUpErrors", void 0),
  _.withHandlers({
    createBooking: props => async () => {
      if (!props.selectedSlot) {
        return alert("Please, choose a time slot");
      }

      const { main, sub, notes } = JSON.parse(
        parse(props.location.search).selection
      );
      const { id } = props.match.params;

      try {
        const booking = await bookTime({
          body: {
            insider: id === "consultation" ? "consultation" : +id,
            time_slot: props.selectedSlot,
            main_objective: main,
            objectives: sub,
            additional_notes: notes
          }
        });
        fbPixel.fbq("trackCustom", "OpenBookingCreated");
        dataLayer.push({
          event: "OpenBookingCreated"
        });
        mixpanel.trackEvent("Open Booking Created");

        document.location.href =
          "/insiders/" +
          props.match.params.id +
          `/payment?bookingId=${booking.id}`;
      } catch (err) {
        alert(R.path(["data", "message"], err) || "Something went wrong");
      }
    }
  }),
  withPromise("signUp", signUp, props =>
    _.compose(
      onSuccess(res => {
        props.setError(void 0);
        props.setSignUpErrors(void 0);
        props.dispatch(manualSignIn(res.key));
        mixpanel.setUser(res.id, {
          $first_name: res.first_name,
          $last_name: res.last_name,
          $email: res.email,
          Purchases: 0
        });
        props.createBooking();
      }),
      onFailure(err => {
        if (err.data && err.data.non_field_errors) {
          return props.setError(
            R.path(["data", "non_field_errors", 0], err) ||
              "Something went wrong"
          );
        }

        if (typeof err.data === "object") {
          return props.setSignUpErrors(R.mapObjIndexed(R.head, err.data));
        }

        props.setError("Something went wrong");
      })
    )
  ),
  withPromise("signIn", signIn, props =>
    _.compose(
      onSuccess(res => {
        props.setError(void 0);
        props.dispatch(manualSignIn(res.key));
        props.createBooking();
      }),
      onFailure(err => {
        props.setError(
          R.path(["data", "non_field_errors", 0], err) || "Something went wrong"
        );
      })
    )
  ),
  _.withHandlers({
    onSignInSubmit: props => body => {
      props.signIn.fetch({ body });
    },
    onSignUpSubmit: props => body => {
      props.signUp.fetch({ body });
    }
  })
)(View);



// WEBPACK FOOTER //
// ./src/components/pages/Candidate/ChooseTime/components/Info/Provider.js